export default __webpack_public_path__ + "static/media/barley.4aac6ba5.png";